<template>
  <div class="customer">
    <div class="left">
      <address-view v-if="this.dataLoaded" />
    </div>
    <div class="right">
      <div class="top"><logo-view /></div>
      <span class="middle">
        <vat-view
          v-if="
            this.$store.state.customerData.customerType == 2 &&
              customerCountryInsideEu
          "
        />
      </span>
      <div class="bottom">
        <button v-bind:disabled="saveInProgress" v-on:click="saveCustomeData">
          SAVE CUSTOMER DATA
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import AddressView from "@/components/Checkout/Address.vue";
import VatView from "@/components/Checkout/Vat.vue";
import LogoView from "@/components/Checkout/Logo.vue";

export default {
  name: "customer-view",
  data() {
    return {
      saveInProgress: false,
      dataLoaded: false,
    };
  },
  components: {
    "address-view": AddressView,
    "vat-view": VatView,
    "logo-view": LogoView,
  },
  computed: {
    customerCountryInsideEu() {
      if (
        this.getCountryWithId(this.$store.state.customerData.country) != null
      ) {
        if (
          this.getCountryWithId(this.$store.state.customerData.country).tax !=
          null
        ) {
          return true;
        }
      }
      return false;
    },
  },
  async mounted() {
    await this.$store.dispatch("getSubscription");
    await this.$store.dispatch("getCountries");
    await this.$store.dispatch("getSubscriptionCustomer");
    this.dataLoaded = true;
  },
  methods: {
    getCountryWithId(countryId) {
      for (let i = 0; i < this.$store.state.countries.length; i++) {
        if (this.$store.state.countries[i].id == countryId) {
          return this.$store.state.countries[i];
        }
      }
      return null;
    },
    async saveCustomeData() {
      this.saveInProgress = true;
      if (this.checkFormData()) {
        await this.$store.dispatch("updateCustomer");
      }
      this.saveInProgress = false;
    },
    checkFormData() {
      let formDataValid = true;

      if (
        this.$store.state.customerData.email == "" ||
        this.$store.state.customerData.email == null
      ) {
        this.$store.commit("assignEmailValid", "red");
        formDataValid = false;
      } else {
        this.$store.commit("assignEmailValid", "#e7e7e7");
      }
      if (
        this.$store.state.customerData.firstname == "" ||
        this.$store.state.customerData.firstname == null
      ) {
        this.$store.commit("assignFirstnameValid", "red");
        formDataValid = false;
      } else {
        this.$store.commit("assignFirstnameValid", "#e7e7e7");
      }
      if (
        this.$store.state.customerData.secondname == "" ||
        this.$store.state.customerData.secondname == null
      ) {
        this.$store.commit("assignSecondnameValid", "red");
        formDataValid = false;
      } else {
        this.$store.commit("assignSecondnameValid", "#e7e7e7");
      }
      if (
        (this.$store.state.customerData.company == "" ||
          this.$store.state.customerData.company == null) &&
        this.$store.state.customerData.customerType != 1
      ) {
        this.$store.commit("assignCompanyValid", "red");
        formDataValid = false;
      } else {
        this.$store.commit("assignCompanyValid", "#e7e7e7");
      }
      if (
        this.$store.state.customerData.street == "" ||
        this.$store.state.customerData.street == null
      ) {
        this.$store.commit("assignStreetValid", "red");
        formDataValid = false;
      } else {
        this.$store.commit("assignStreetValid", "#e7e7e7");
      }
      if (
        this.$store.state.customerData.houseNumber == "" ||
        this.$store.state.customerData.houseNumber == null
      ) {
        this.$store.commit("assignHouseNumberValid", "red");
        formDataValid = false;
      } else {
        this.$store.commit("assignHouseNumberValid", "#e7e7e7");
      }
      if (
        this.$store.state.customerData.zip == "" ||
        this.$store.state.customerData.zip == null
      ) {
        this.$store.commit("assignZipValid", "red");
        formDataValid = false;
      } else {
        this.$store.commit("assignZipValid", "#e7e7e7");
      }
      if (
        this.$store.state.customerData.city == "" ||
        this.$store.state.customerData.city == null
      ) {
        this.$store.commit("assignCityValid", "red");
        formDataValid = false;
      } else {
        this.$store.commit("assignCityValid", "#e7e7e7");
      }
      if (
        this.$store.state.customerData.customerType == 2 &&
        this.customerCountryInsideEu &&
        this.$store.state.customerData.vatId != "" &&
        this.$store.state.customerData.vatId != null
      ) {
        if (this.$store.state.vatCheckSuccessfull == false) {
          this.$store.commit("assignVatValid", "red");
          formDataValid = false;
        } else {
          this.$store.commit("assignVatValid", "#e7e7e7");
        }
      } else {
        this.$store.commit("assignVatValid", "#e7e7e7");
      }
      return formDataValid;
    },
  },
};
</script>

<style scoped>
.customer {
  width: 100%;
  height: 88.5%;
  display: flex;
  padding-top: 30px;
  padding-bottom: 30px;
}

.left {
  width: 50%;
  height: 100%;
  padding-left: 60px;
  padding-right: 60px;
  border-right: 1px solid #c7c9c8;
}

.right {
  width: 50%;
  height: 100%;
  padding-left: 60px;
  padding-right: 60px;
  border-left: 1px solid #c7c9c8;
}

.right .top {
  display: flex;
  height: 12%;
  margin-bottom: 20px;
}

.right .middle {
  height: 50%;
  display: flex;
}

.right .bottom {
  justify-content: flex-end;
  display: flex;
}

button:hover {
  background-color: #fdd86a;
}

button:disabled {
  background-color: #888888;
  border-color: #888888;
}

button {
  cursor: pointer;
  background-color: #ffc20f;
  border: 1px solid #ffc20f;
  border-radius: 3px;
  color: white;
  outline: none;
  height: 40px;
  padding-right: 20px;
  padding-left: 20px;
}
</style>
